import { useSelector } from "react-redux";
import Card from "../common/Card";
import { formatNumber } from "../utils/DateFormat";
import { QA_ROLES } from "../constant";

const OverviewSection = ({ overviewData }) => {
  const role = useSelector((state) => state.auth.role);

  return (
    <>
      <div className="mb-4">
        <div className="title">
          <h6>Overview</h6>
        </div>

        <div
          className="d-grid gap-2 gap-md-3"
          style={{ gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}
        >
          <Card title="Total calls" status={formatNumber(overviewData?.total)} />
          <Card title="Completed" status={formatNumber(overviewData?.COMPLETED)} />
          {QA_ROLES.includes(role)? (
            <Card title="Assigned" status={formatNumber(overviewData?.ASSIGNED)} color="yellow" />
          ) : (
            <>
              <Card title="Assigned" status={formatNumber(overviewData?.ASSIGNED)} />
              <Card title="Pending" status={formatNumber(overviewData?.PENDING)} color="yellow" />
            </>
          )}
          <Card title="QA reviewed" status={formatNumber(overviewData?.REVIEWED)} />
        </div>
      </div>
    </>
  );
};

export default OverviewSection;
